import Api from "./base/api-base";

export default class UserPolicysApi {

  info() {
    return Api.get({
      endpoint: Api.endpoint.user_policys
    });
  }
  update (date) {
    return Api.post({
      endpoint: Api.endpoint.user_policys,
      id: date
    });
  }
}